import './App.css';
import Router from './router/routes.jsx'

function App() {
  return (
    <Router />
  );
}

export default App;
